import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    data: [],
    loading: false,
    error: null
};

const organizationsSlice = createSlice({
    name: "organizations",
    initialState,
    reducers: {
        OrganizationsRequest: (state) => {
            state.loading = true;
            state.error = null;
        },
        OrganizationsSuccess: (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.error = null;
        },
        OrganizationsError: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        }
    }
});

export const { OrganizationsRequest, OrganizationsSuccess, OrganizationsError } = organizationsSlice.actions;
export default organizationsSlice.reducer;
